import {createLogger} from "../../common/logging.config";


const template = require('./shutterstockFootage.html');
require('./shutterstockFootage.scss');

const logger = createLogger('shutterstock-footage');


class shutterStockFootageController {

	constructor($scope, shutterstockService, $translate, homepageUtil, tenantRegistryService, shellUtil) {
	    this.$translate = $translate;
	    this.homepageUtil = homepageUtil;
	    this.shellUtil = shellUtil;
	    this.shutterstockService = shutterstockService;

        this.imageOverages = 0;
        this.usageLoaded = false;
        this.getShutterstockFootageLicense();
    }

    getShutterstockFootageLicense(){
        return this.shutterstockService.getShutterstockEnabled().then(
            (data) =>{
                if (data.licenses){
                    this.footageUsed = data.licenses[1].used;
                    this.footageEntitled = data.licenses[1].entitled;
                    this.footageOverages = data.licenses[1].overages;
                    this.usageLoaded = true;
                    return true;
                }

                // No license in this case
                return false;
            },
            (error) =>{
                logger.error('Error retrieving shutterstock info: ' + error);
                return false;
            }
        );
    }

    getFootageUsagePercentStyle(){
	    if (!this.usageLoaded){
	        return {
                "height": 0
            };
        }

        return {
            "height": (this.footageUsed / this.footageEntitled * 100).toFixed(2) + '%'
        };
    }

    getRemaining(){
	    if (!this.usageLoaded){
	        return 0;
        }
	    const remainNum = this.footageEntitled - this.footageUsed;
	    if (remainNum >= 0){
	        return remainNum;
        }
        else {
	        return '+' + (0 - remainNum);
        }
	}


};

module.exports = {
	templateUrl: template,
	controller: ["$scope", "shutterstockService","$translate", "homepageUtil", "tenantRegistryService", "shellUtil", shutterStockFootageController]
};



// WEBPACK FOOTER //
// ./app/components/shutterstockFootage/shutterstockFootage.component.js